{
  "loading": "Carregando comentários...",
  "title": "Comentários ({{total}})",
  "placeholder": "Deixe seu comentário...",
  "submit": "Comentar",
  "empty": "Nenhum comentário ainda. Seja o primeiro!",
  "badges": {
    "admin": "Admin",
    "instructor": "Instrutor"
  },
  "edited": "(editado)",
  "actions": {
    "save": "Salvar",
    "cancel": "Cancelar",
    "reply": "Responder",
    "edit": "Editar",
    "pin": "Fixar",
    "unpin": "Desfixar",
    "delete": "Deletar"
  },
  "replyPlaceholder": "Escreva uma resposta...",
  "viewReplies_one": "Ver {{count}} resposta",
  "viewReplies_zero": "Ver {{count}} respostas",
  "viewReplies_other": "Ver {{count}} respostas",
  "toast": {
    "created": "Comentário criado com sucesso!",
    "createError": "Erro ao criar comentário",
    "updated": "Comentário atualizado!",
    "updateError": "Erro ao atualizar comentário",
    "deleted": "Comentário deletado!",
    "deleteError": "Erro ao deletar comentário",
    "pinToggled": "Comentário fixado/desfixado!",
    "pinError": "Erro ao fixar comentário"
  }
}
